// Configuración de números de WhatsApp por UTM parameters
export const whatsappConfig = {
  // Número por defecto (original)
  default: {
    number: "+543516825130",
    message: "Hola Montironi Ford!",
  },

  // Configuración para TikTok
  tiktok: {
    number: "+5493516521609",
    message: "Hola Montironi Ford! Quisiera más información sobre sus vehículos.",
    utm_source: "tiktok",
    utm_medium: "paid",
    campaigns: {
      "smart-lead": {
        number: "+5493516521609",
        message: "Hola Montironi Ford! Quisiera más información sobre sus vehículos Smart.",
      },
      lead: {
        number: "+5493516521609",
        message: "Hola Montironi Ford! Quisiera más información sobre sus vehículos.",
      },
    },
  },
};

// Función para obtener la URL de WhatsApp según los UTM parameters
export const getWhatsAppUrl = (utmParams = {}) => {
  const { utm_source, utm_medium, utm_campaign } = utmParams;

  // Si es TikTok con campaña específica
  if (utm_source === "tiktok" && utm_campaign) {
    const tiktokConfig = whatsappConfig.tiktok;
    const campaignConfig = tiktokConfig.campaigns[utm_campaign];

    if (campaignConfig) {
      const encodedMessage = encodeURIComponent(campaignConfig.message);
      return `https://api.whatsapp.com/send?phone=${campaignConfig.number}&text=${encodedMessage}`;
    }
  }

  // Si es TikTok general
  if (utm_source === "tiktok") {
    const tiktokConfig = whatsappConfig.tiktok;
    const encodedMessage = encodeURIComponent(tiktokConfig.message);
    return `https://api.whatsapp.com/send?phone=${tiktokConfig.number}&text=${encodedMessage}`;
  }

  // Si es otro source configurado
  if (utm_source && whatsappConfig[utm_source]) {
    const config = whatsappConfig[utm_source];
    const encodedMessage = encodeURIComponent(config.message);
    return `https://api.whatsapp.com/send?phone=${config.number}&text=${encodedMessage}`;
  }

  // URL por defecto
  const defaultConfig = whatsappConfig.default;
  const encodedMessage = encodeURIComponent(defaultConfig.message);
  return `https://api.whatsapp.com/send?phone=${defaultConfig.number}&text=${encodedMessage}`;
};

// Función para extraer UTM parameters de la URL actual
export const getUtmParams = () => {
  const query = new URLSearchParams(window.location.search);
  return {
    utm_source: query.get("utm_source") || sessionStorage.getItem("utm_source"),
    utm_medium: query.get("utm_medium") || sessionStorage.getItem("utm_medium"),
    utm_campaign: query.get("utm_campaign") || sessionStorage.getItem("utm_campaign"),
    utm_term: query.get("utm_term") || sessionStorage.getItem("utm_term"),
  };
};

// Función para guardar UTM parameters en sessionStorage
export const saveUtmParams = () => {
  const query = new URLSearchParams(window.location.search);
  if (query) {
    if (query.get("utm_source")) {
      sessionStorage.setItem("utm_source", query.get("utm_source"));
    }
    if (query.get("utm_medium")) {
      sessionStorage.setItem("utm_medium", query.get("utm_medium"));
    }
    if (query.get("utm_campaign")) {
      sessionStorage.setItem("utm_campaign", query.get("utm_campaign"));
    }
    if (query.get("utm_term")) {
      sessionStorage.setItem("utm_term", query.get("utm_term"));
    }
  }
};
